import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import GenericError from './Errors/GenericError';
import UnhandledError from './Errors/UnhandledError';
import FullPageError from '../components/FullPageError';
import { flagEnabled } from '../helpers/featureFlags';
import Routes from '../routes';

import { setApplePay } from '../actions/applePay';
import { resetUserMessages } from '../actions/userMessages';
import PageApp from './Layouts/PageApp';

export class App extends Component {
  async componentDidMount() {
    const {
      handleSetApplePay,
    } = this.props;
    handleSetApplePay();
    if (window.location.search.includes('app=1')) {
      sessionStorage.setItem('isFromApp', 'true');
    }
  }

  renderAppState() {
    const {
      error,
      errorData,
    } = this.props;

    if (error) {
      if (flagEnabled('xmPaymentReskinEnabled')) {
        return (
          <FullPageError
            error={errorData}
            iconName="info"
            title="Something unexpected happened."
            subtitle="Try refreshing the page. If the problem persists, please check back later."
          />
        );
      }
      return <GenericError error={errorData} />;
    }

    return <Routes {...this.props} />;
  }

  render() {
    const {
      isHarness,
      device,
      showModal,
      handleResetUserMessages,
    } = this.props;

    const pageClassNames = [];

    if (isHarness) {
      pageClassNames.push('page-app--harnessed');
      pageClassNames.push(`page-app--${device}`);
    }

    return (
      <PageApp classNames={pageClassNames}>
        {showModal && <UnhandledError closeModal={handleResetUserMessages} />}
        {this.renderAppState()}
      </PageApp>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    auth: { crsId, errorData },
    userMessages: { showModal },
    harness: {
      device,
      isHarness,
    },
  } = state;

  return ({
    device,
    isHarness,
    showModal,
    errorData,
    crsId,
  });
};

const mapDispatchToProps = dispatch => bindActionCreators({
  handleSetApplePay: setApplePay,
  handleResetUserMessages: resetUserMessages,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);
